import { GuaranteeTypeEnum } from '@insurance/api/requests'
import { InputDatePicker } from '@insurance/components'
import { useValidationsField } from '@insurance/hooks'
import { Col, Divider, Form, Row, Select } from 'antd'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

import { AmountFields } from './AmountFields'
import { GuaranteedObligationField } from './GuaranteedObligationField'
import { GuaranteeTypeFields } from './GuaranteeTypeFields'
import { formProps, GUARANTEE_TYPE_LABEL_KEY } from './utils'

export const GuaranteeStep = () => {
  const { t } = useTranslation()
  const { required } = useValidationsField()
  const formInstance = Form.useFormInstance()

  const { guaranteeTypeProps, validFromProps, validToProps, detailsProps } =
    formProps(t)

  const validFrom = Form.useWatch(validFromProps.name, {
    preserve: true
  })
  const validTo = Form.useWatch(validToProps.name, { preserve: true })

  const guaranteeTypeOptions = Object.values(GuaranteeTypeEnum).map(
    (value) => ({
      value,
      label: t(GUARANTEE_TYPE_LABEL_KEY[value])
    })
  )

  // Stale values from the previously selected type would be rejected by the
  // backend, which accepts only the block belonging to `guarantee_type`.
  const handleTypeChange = () =>
    formInstance.setFieldValue(detailsProps.name, undefined)

  return (
    <>
      <Row gutter={[12, 12]}>
        <Col xs={24}>
          <Form.Item {...guaranteeTypeProps} rules={[required]}>
            <Select
              placeholder={guaranteeTypeProps.label}
              options={guaranteeTypeOptions}
              onChange={handleTypeChange}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[12, 12]}>
        <Col xs={24} lg={12}>
          <Form.Item {...validFromProps} rules={[required]}>
            <InputDatePicker
              placeholder={validFromProps.label}
              minDate={dayjs()}
              maxDate={validTo ? dayjs(validTo) : undefined}
              allowClear={false}
            />
          </Form.Item>
        </Col>

        <Col xs={24} lg={12}>
          <Form.Item {...validToProps} rules={[required]}>
            <InputDatePicker
              placeholder={validToProps.label}
              minDate={validFrom ? dayjs(validFrom) : dayjs()}
              allowClear={false}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[12, 12]}>
        <Col xs={24}>
          <GuaranteedObligationField />
        </Col>
      </Row>

      <GuaranteeTypeFields />

      <Divider />

      <AmountFields />
    </>
  )
}
